"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = _interopRequireDefault(require("../../loader/image"));
var _productModule = _interopRequireDefault(require("./product.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ProductCard = exports.ProductCard = function ProductCard(props) {
  var getClassName = function getClassName(props) {
    return "".concat(_productModule["default"].card, " ").concat(props.active && _productModule["default"].active);
  };
  var _onClick = function onClick(props) {
    !props.active && props.onClick(props.id);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "product-card",
    className: getClassName(props),
    onClick: function onClick() {
      return _onClick(props);
    }
  }, /*#__PURE__*/_react["default"].createElement(_image["default"], {
    src: props.url,
    alt: props.name,
    width: 47,
    height: 47,
    fallbackIconType: "TShirt",
    fallbackIconFontSize: 25
  }));
};
ProductCard.propTypes = {
  id: _propTypes["default"].number,
  url: _propTypes["default"].string,
  name: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
ProductCard.defaultProps = {
  id: 0,
  url: "",
  name: "",
  active: false
};
var _default = exports["default"] = ProductCard;